/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/close_medium'
export default icon
